module.exports = __webpack_public_path__ + "img/budget-spent-icon.efb4fda2.svg";